/*
  veride-story.js

  Разбирает тело поста и превращает простые пометки, набранные прямо
  в редакторе Shopify, в элементы из veride-story.css. HTML-режим
  редактора для этого не нужен.

  В строке текста:
    ((фраза))   — рукописная обводка
    __фраза__   — рукописное подчёркивание
    ==фраза==   — мягкий маркер
    ~~фраза~~   — рукописный почерк

  Отдельной строкой перед абзацем или картинкой:
    [[lead]]    — абзац-вступление
    [[note]]    — заметка на полях
    [[quote]]   — врезка-цитата
    [[left]] / [[right]] / [[wide]] / [[pair]] — раскладка картинки
    [[deck]]    — карточки, которые листаются вбок
    [[top]]     — в колоде: вопрос к верху кадра, а не к низу
    [[break]]   — конец обтекания: дальше текст во всю ширину
    ---  или  ***  — разделитель

  Картинка, стоящая в абзаце одна, становится <figure>. Если сразу
  за ней идёт абзац целиком курсивом — он становится подписью.
*/
(function () {
  'use strict';

  var CIRCLE_PATH =
    'M 66 6 C 94 3 118 7 113 21 C 110 32 92 41 58 39 C 30 37 3 33 7 19 C 11 8 38 3 72 6 C 84 7 92 9 96 11';

  var INLINE_RULES = [
    { pattern: /\(\((.+?)\)\)/g, className: 'vs-circle' },
    { pattern: /__(.+?)__/g, className: 'vs-underline' },
    { pattern: /==(.+?)==/g, className: 'vs-mark' },
    { pattern: /~~(.+?)~~/g, className: 'vs-hand' }
  ];

  var BLOCK_DIRECTIVES = {
    lead: 'vs-lead',
    note: 'vs-note',
    quote: 'vs-quote',
    left: 'vs-figure--left',
    right: 'vs-figure--right',
    wide: 'vs-figure--wide',
    pair: 'vs-figure--pair',
    deck: 'vs-figure--deck',
    top: 'vs-figure--top'
  };

  var ARROW_PATH = 'M5 1.5 11.5 8 5 14.5';

  var DIRECTIVE_RE = /^\[\[\s*([a-z]+)\s*\]\]$/i;
  var DIVIDER_RE = /^(-{3,}|\*{3,}|—{3,})$/;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, CODE: 1, PRE: 1, TEXTAREA: 1 };

  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* Вставка из Google Docs заворачивает каждый кусок фразы в
     <span style="font-family: Roboto; …">. Такие обёртки мешают
     дважды: перебивают шрифт темы и рвут пометку на части, если она
     попала на границу двух span. Разворачиваем их — кроме тех, где
     автор сознательно задал подчёркивание или зачёркивание. */
  function unwrapPastedSpans(root) {
    var spans = root.querySelectorAll('span[style]');

    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var style = span.getAttribute('style') || '';

      if (span.className) continue;
      if (/underline|line-through/i.test(style)) continue;

      var parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    }

    root.normalize();
  }

  /* Пометка в отдельной строке относится к следующему за ней блоку.
     Саму строку убираем, а класс вешаем на соседа. */
  function applyBlockDirectives(root) {
    var blocks = Array.prototype.slice.call(root.children);

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var text = (block.textContent || '').trim();

      if (DIVIDER_RE.test(text) && !block.querySelector('img')) {
        var divider = document.createElement('div');
        divider.className = 'vs-divider';
        divider.setAttribute('aria-hidden', 'true');
        block.parentNode.replaceChild(divider, block);
        continue;
      }

      var match = text.match(DIRECTIVE_RE);
      if (!match) continue;

      var name = match[1].toLowerCase();

      // [[break]] ничего не оформляет — просто обрывает обтекание
      if (name === 'break') {
        var brk = document.createElement('div');
        brk.className = 'vs-break';
        brk.setAttribute('aria-hidden', 'true');
        block.parentNode.replaceChild(brk, block);
        continue;
      }

      var target = block.nextElementSibling;
      if (BLOCK_DIRECTIVES[name] && target) {
        target.setAttribute('data-vs', name);
      }
      block.parentNode.removeChild(block);
    }
  }

  function isCaption(element) {
    if (!element || element.tagName !== 'P') return false;
    if (element.querySelector('img')) return false;
    if (!(element.textContent || '').trim()) return false;

    var children = element.children;
    if (!children.length) return false;

    for (var i = 0; i < children.length; i++) {
      var tag = children[i].tagName;
      if (tag !== 'EM' && tag !== 'I' && tag !== 'BR') return false;
    }
    return true;
  }

  /* Картинка (или две), стоящая в абзаце одна, превращается в figure.
     Класс раскладки берётся из пометки [[…]], а пара картинок
     становится рядом и без пометки. */
  function buildFigures(root) {
    var images = Array.prototype.slice.call(root.querySelectorAll('img'));
    var handled = [];

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      if (image.closest && image.closest('.vs-figure')) continue;

      var block = image.parentNode;

      while (block && block !== root && block.tagName !== 'P' && block.tagName !== 'DIV') {
        block = block.parentNode;
      }
      if (!block || block === root) {
        block = image;
      }
      if (handled.indexOf(block) !== -1) continue;

      // Картинка в одной строке с текстом остаётся как есть
      if (block !== image && (block.textContent || '').trim()) continue;

      handled.push(block);

      var figure = document.createElement('figure');
      figure.className = 'vs-figure';

      var directive = block.getAttribute && block.getAttribute('data-vs');
      if (directive && BLOCK_DIRECTIVES[directive]) {
        figure.classList.add(BLOCK_DIRECTIVES[directive]);
      }

      var next = block.nextElementSibling;
      block.parentNode.replaceChild(figure, block);

      if (block === image) {
        figure.appendChild(image);
      } else {
        while (block.firstChild) {
          figure.appendChild(block.firstChild);
        }
      }

      if (figure.querySelectorAll('img').length > 1) {
        figure.classList.add('vs-figure--pair');
      }

      if (isCaption(next)) {
        var caption = document.createElement('figcaption');
        while (next.firstChild) {
          caption.appendChild(next.firstChild);
        }
        next.parentNode.removeChild(next);
        figure.appendChild(caption);
      }
    }
  }

  function isBlank(element) {
    return !element.querySelector('img') && !(element.textContent || '').trim();
  }

  /* Картинка сбоку — это не обтекание, а пара колонок: текст рядом
     встаёт по центру по высоте, чего float не умеет в принципе.
     В колонку с текстом собирается всё, что идёт за картинкой, до
     следующей пометки. */
  function buildSideRows(root) {
    var figures = root.querySelectorAll('.vs-figure--left, .vs-figure--right');
    var STOPPERS = '.vs-figure, .vs-divider, .vs-break, .vs-side';

    for (var i = 0; i < figures.length; i++) {
      var figure = figures[i];
      var group = [];
      var next = figure.nextElementSibling;

      while (next) {
        if (next.matches && next.matches(STOPPERS)) break;
        if (next.hasAttribute && next.hasAttribute('data-vs')) break;
        if (next.querySelector && next.querySelector('img')) break;
        group.push(next);
        next = next.nextElementSibling;
      }

      // пустые строки по краям колонки сбивают центрирование
      while (group.length && isBlank(group[0])) group.shift();
      while (group.length && isBlank(group[group.length - 1])) group.pop();
      if (!group.length) continue;

      var side = document.createElement('div');
      side.className = 'vs-side ' +
        (figure.classList.contains('vs-figure--left') ? 'vs-side--left' : 'vs-side--right');

      var text = document.createElement('div');
      text.className = 'vs-side__text';

      figure.parentNode.insertBefore(side, figure);
      side.appendChild(figure);
      for (var j = 0; j < group.length; j++) {
        text.appendChild(group[j]);
      }
      side.appendChild(text);
    }
  }

  /* Колода — [[deck]]: карточки, которые листаются вбок. Пометка стоит
     один раз, перед первой картинкой; дальше каждая картинка начинает
     новую карточку, а всё, что идёт за ней до следующей картинки,
     становится её подписью. Ряд заканчивается на разделителе, [[break]]
     или любой другой пометке. */
  function buildDecks(root) {
    var starts = root.querySelectorAll('.vs-figure--deck');
    var STOPPERS = '.vs-divider, .vs-break, .vs-side, .vs-deck';

    for (var i = 0; i < starts.length; i++) {
      var first = starts[i];
      if (first.closest('.vs-deck')) continue;

      var deck = document.createElement('div');
      deck.className = 'vs-deck';

      var track = document.createElement('div');
      track.className = 'vs-deck__track';
      deck.appendChild(track);

      first.parentNode.insertBefore(deck, first);

      var node = first;
      while (node && node.matches && node.matches('.vs-figure')) {
        if (node !== first && node.hasAttribute('data-vs')) break;

        var card = document.createElement('div');
        card.className = 'vs-deck__card';
        var text = document.createElement('div');
        text.className = 'vs-deck__text';

        var next = node.nextElementSibling;
        track.appendChild(card);
        card.appendChild(node);
        card.appendChild(text);

        // [[top]] перед картинкой поднимает вопрос к верху кадра
        if (node.classList.contains('vs-figure--top')) {
          card.classList.add('vs-deck__card--top');
        }

        while (next && !(next.matches(STOPPERS) || next.matches('.vs-figure'))) {
          if (next.hasAttribute('data-vs')) break;
          var after = next.nextElementSibling;
          if (isBlank(next)) {
            next.parentNode.removeChild(next);
          } else {
            text.appendChild(next);
          }
          next = after;
        }

        // Карточка без подписи — значит вопрос набит на самом кадре.
        // Пустую подложку убираем, иначе она затемнит фото ни за чем.
        if (!text.childNodes.length) {
          card.removeChild(text);
        }

        node = next;
      }

      buildDeckNav(deck, track);
    }
  }

  function buildDeckNav(deck, track) {
    var cards = track.children;
    if (cards.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'vs-deck__nav';

    var prev = deckArrow('prev', 'Previous');
    var next = deckArrow('next', 'Next');
    var count = document.createElement('span');
    count.className = 'vs-deck__count';
    count.setAttribute('aria-hidden', 'true');

    var dots = document.createElement('ul');
    dots.className = 'vs-deck__dots';

    for (var i = 0; i < cards.length; i++) {
      var item = document.createElement('li');
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vs-deck__dot';
      dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      dot.innerHTML = '<span class="visually-hidden">' + (i + 1) + '</span>';
      item.appendChild(dot);
      dots.appendChild(item);
    }

    /* Строка управления стоит над рядом по ширине кадра: счётчик в
       левом верхнем углу, стрелки — в правом. Точки остаются под
       рядом. Так управление не отбирает место у карточки. */
    var arrows = document.createElement('div');
    arrows.className = 'vs-deck__arrows';
    arrows.appendChild(prev);
    arrows.appendChild(next);

    nav.classList.add('vs-deck__nav--top');
    nav.appendChild(count);
    nav.appendChild(arrows);
    deck.insertBefore(nav, track);
    deck.appendChild(dots);

    track.setAttribute('tabindex', '0');
    track.setAttribute('aria-label', 'Cards');

    wireDeck(deck, track, prev, next, count, dots);
    deck.classList.add('is-ready');
  }

  function deckArrow(kind, label) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vs-deck__arrow vs-deck__arrow--' + kind;
    button.setAttribute('aria-label', label);
    button.innerHTML =
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="' +
      ARROW_PATH +
      '"/></svg>';
    return button;
  }

  /* Доля карточки, которую видно от соседей слева и справа. */
  var DECK_SLIVER = 0.1;

  /* Ряд ведём сами, а не браузерным smooth: у него своё ускорение,
     одинаковое на короткий и длинный ход. Своя кривая тормозит мягко
     и одинаково, сколько бы карточек ни пролистнули. */
  var DECK_GLIDE_MS = 560;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function wireDeck(deck, track, prev, next, count, dots) {
    var cards = Array.prototype.slice.call(track.children);
    var buttons = Array.prototype.slice.call(dots.querySelectorAll('button'));
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;

    /* Ряд ровно под одну карточку плюс два краешка соседних. Ширину
       карточки задаёт картинка, поэтому считаем от неё, а не наоборот —
       иначе ряд и карточка начнут гоняться друг за другом. Те же поля
       по краям позволяют довести до центра первую и последнюю. */
    function layout() {
      var width = cards[0].offsetWidth;
      if (!width) return;

      deck.style.maxWidth = Math.round(width * (1 + DECK_SLIVER * 2)) + 'px';
      /* Строке управления нужна ширина кадра — из CSS её не достать:
         её задаёт картинка. */
      deck.style.setProperty('--vs-deck-card', width + 'px');

      /* Ряд мог оказаться уже задуманного — его режет столбец текста.
         Поэтому поля считаем по факту: ровно столько, чтобы карточка
         встала по центру, иначе к центру её не довести. */
      var gap = Math.max(0, (track.clientWidth - width) / 2);
      track.style.paddingLeft = gap + 'px';
      track.style.paddingRight = gap + 'px';
    }

    /* Прокрутка, при которой карточка стоит по центру ряда. */
    function targetOf(i) {
      return (
        cards[i].offsetLeft -
        track.offsetLeft -
        (track.clientWidth - cards[i].offsetWidth) / 2
      );
    }

    function sync() {
      prev.disabled = index <= 0;
      next.disabled = index >= cards.length - 1;
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-current', i === index ? 'true' : 'false');
        cards[i].classList.toggle('is-current', i === index);
      }
      count.textContent = index + 1 + ' / ' + cards.length;
    }

    /* Пока ведём ряд сами, снап выключен: иначе он на каждом кадре
       дёргает прокрутку к ближайшей карточке и ход получается рваным.
       В конце возвращаем — ряд уже стоит ровно на точке снапа. */
    var glide = null;

    function stopGlide() {
      if (!glide) return;
      window.cancelAnimationFrame(glide);
      glide = null;
      track.style.scrollSnapType = '';
    }

    function glideTo(left) {
      stopGlide();

      if (reduced.matches) {
        track.scrollLeft = left;
        return;
      }

      var from = track.scrollLeft;
      var delta = left - from;
      if (Math.abs(delta) < 1) return;

      track.style.scrollSnapType = 'none';

      var start = null;
      glide = window.requestAnimationFrame(function step(now) {
        if (start === null) start = now;
        var passed = Math.min(1, (now - start) / DECK_GLIDE_MS);
        track.scrollLeft = from + delta * easeOutCubic(passed);
        if (passed < 1) {
          glide = window.requestAnimationFrame(step);
        } else {
          glide = null;
          track.style.scrollSnapType = '';
        }
      });
    }

    function goTo(target) {
      index = Math.max(0, Math.min(target, cards.length - 1));
      var max = track.scrollWidth - track.clientWidth;
      glideTo(Math.max(0, Math.min(targetOf(index), max)));
      sync();
    }

    /* Палец, колесо и трекпад главнее нашей анимации: как только
       читатель тронул ряд, ведение прекращается. */
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (name) {
      track.addEventListener(name, stopGlide, { passive: true });
    });

    prev.addEventListener('click', function () {
      goTo(index - 1);
    });
    next.addEventListener('click', function () {
      goTo(index + 1);
    });
    buttons.forEach(function (button, i) {
      button.addEventListener('click', function () {
        goTo(i);
      });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(index + (event.key === 'ArrowRight' ? 1 : -1));
    });

    /* Палец и трекпад двигают ряд мимо кнопок — позицию читаем сами,
       но не на каждом кадре прокрутки. */
    var frame = null;
    track.addEventListener(
      'scroll',
      function () {
        /* Пока ряд ведём мы, позицию не переспрашиваем: на полпути
           ближайшей окажется ещё старая карточка и счётчик мигнёт. */
        if (frame || glide) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          var origin = track.scrollLeft;
          var best = 0;
          var closest = Infinity;
          for (var i = 0; i < cards.length; i++) {
            var distance = Math.abs(targetOf(i) - origin);
            if (distance < closest) {
              closest = distance;
              best = i;
            }
          }
          index = best;
          sync();
        });
      },
      { passive: true }
    );

    /* Размер карточки идёт от размеров окна — пересчитываем ряд при
       повороте телефона и перетаскивании окна. */
    function relayout() {
      layout();
      goTo(index);
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(relayout).observe(document.documentElement);
    } else {
      window.addEventListener('resize', relayout);
    }

    layout();
    sync();
  }

  function applyPendingBlockClasses(root) {
    var marked = root.querySelectorAll('[data-vs]');

    for (var i = 0; i < marked.length; i++) {
      var element = marked[i];
      var className = BLOCK_DIRECTIVES[element.getAttribute('data-vs')];
      if (className && className.indexOf('vs-figure') !== 0) {
        element.classList.add(className);
      }
      element.removeAttribute('data-vs');
    }
  }

  function decorateTextNode(node) {
    var text = node.nodeValue;
    var hasMark = false;

    for (var i = 0; i < INLINE_RULES.length; i++) {
      INLINE_RULES[i].pattern.lastIndex = 0;
      if (INLINE_RULES[i].pattern.test(text)) {
        hasMark = true;
        break;
      }
    }
    if (!hasMark) return;

    var html = escapeHtml(text);
    for (var j = 0; j < INLINE_RULES.length; j++) {
      var rule = INLINE_RULES[j];
      rule.pattern.lastIndex = 0;
      html = html.replace(rule.pattern, function (whole, inner) {
        return '<span class="' + rule.className + '">' + inner + '</span>';
      });
    }

    var holder = document.createElement('span');
    holder.innerHTML = html;

    var fragment = document.createDocumentFragment();
    while (holder.firstChild) {
      fragment.appendChild(holder.firstChild);
    }
    node.parentNode.replaceChild(fragment, node);
  }

  function decorateInline(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var text = node.nodeValue || '';
        if (!/[(_=~]/.test(text)) return NodeFilter.FILTER_REJECT;

        var parent = node.parentNode;
        if (!parent || SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        if (parent.closest && parent.closest('.vs-circle, .vs-underline, .vs-mark, .vs-hand')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var current;
    while ((current = walker.nextNode())) {
      nodes.push(current);
    }

    for (var i = 0; i < nodes.length; i++) {
      decorateTextNode(nodes[i]);
    }
  }

  /* Овал рисуется поверх фразы отдельным SVG: у background-image
     штрих растянулся бы вместе с картинкой. */
  function drawCircles(root) {
    var circles = root.querySelectorAll('.vs-circle');

    for (var i = 0; i < circles.length; i++) {
      var circle = circles[i];
      if (circle.querySelector('svg')) continue;

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'vs-circle__line');
      svg.setAttribute('viewBox', '0 0 120 44');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('pathLength', '1');
      path.setAttribute('d', CIRCLE_PATH);

      svg.appendChild(path);
      circle.appendChild(svg);
    }
  }

  /* Выделения проявляются, когда до них доскроллили. */
  function revealOnScroll(root) {
    var targets = root.querySelectorAll('.vs-circle, .vs-underline, .vs-mark');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].classList.add('is-drawn');
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-drawn');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    for (var j = 0; j < targets.length; j++) {
      observer.observe(targets[j]);
    }
  }

  function enhance(root) {
    if (!root || root.dataset.vsReady === 'true') return;
    root.dataset.vsReady = 'true';

    unwrapPastedSpans(root);
    applyBlockDirectives(root);
    buildFigures(root);
    buildSideRows(root);
    buildDecks(root);
    applyPendingBlockClasses(root);
    decorateInline(root);
    drawCircles(root);
    revealOnScroll(root);
  }

  function run(scope) {
    var roots = (scope || document).querySelectorAll('.veride-story');
    for (var i = 0; i < roots.length; i++) {
      enhance(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
